import React, { ComponentType } from 'react';
import { useSelector } from 'react-redux';
import { Redirect, useLocation } from 'react-router';

import useIsSignUpLandingVariantEnabled from '../common/hooks/useIsSignUpLandingVariantEnabled';
import { getIsLoggedIn } from '../selectors/session';

export function withDashboardRedirect<P = Record<string, unknown>>(
  WrappedComponent: ComponentType<P>
) {
  const Wrapper = (props: P & JSX.IntrinsicAttributes) => {
    const isLoggedIn = useSelector(getIsLoggedIn);
    const { pathname } = useLocation();
    const isSignUpLandingVariantEnabled = useIsSignUpLandingVariantEnabled();

    // if the variant is sign up, the sign up page will handle the redirection
    // as it contains side effects that needs to be run before navigation
    if (pathname === '/' && isLoggedIn && !isSignUpLandingVariantEnabled) {
      return <Redirect to="/dashboard" />;
    }

    return <WrappedComponent {...props} />;
  };

  return Wrapper;
}
